module.exports = __webpack_public_path__ + "static/media/asterisk.8bf9dd32.svg";